import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'brand_tile-right-action_category_click';

/**
 * An event for when a brand tile is right clicked. 

Parameters:
- requestId: BE-generated request id
- impressionId: BE-generated impression id
- brand token
- screenContext
- containerContext
- token: page specific identifier
 */
export function trackBrandTileRightActionCategoryClick(
  requestId: string,
  impressionId2: string,
  brandToken: string,
  screenContext3: string,
  containerContext4: string,
  token5: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: {
      requestId,
      impressionId2,
      brandToken,
      screenContext3,
      containerContext4,
      token5,
    },
  });
}
